module.exports = __webpack_public_path__ + "img/money-dollar-circle-fill.f6e859a3.svg";